<template>
	<div>
		
		<h1 class="view-title">
			EMPRESAS - LISTAGEM
		</h1>

		<div class="inner-content shadowed">
			<div class="inner-content-title">
				Lista

				<button class="button-edit admin-create-btn" @click="current = 'new'">
					<i class="fa fa-plus"></i> NOVO
				</button>

				<div class="admin-filter-wrapper">
					<input class="admin-filter-input" type="text" placeholder="Buscar" v-model="search" @keydown.enter.prevent="load(true)" />
					<i class="fa fa-fw fa-search"></i>
				</div>
			</div>

			<div class="row">
				<div class="col-xs">
					
					<Table 
					:loading="loading"
					:headers="headers" 
					:modifiers="modifiers" 
					:ordering="[]" 
					:list="list" 
					:page="page"
					:per_page="20" 
					:total="total" 
					@next="() => { page++; load(); }" 
					@prev="() => { page--; load(); }"
					v-slot="{item}">

						<button class="button-edit" @click="show_documents = item" title="Filiais">
							<i class="fa fa-fw fa-building"></i>
						</button>

						<button class="button-edit" @click="current = item" title="Alterar">
							<i class="fa fa-fw fa-edit"></i>
						</button>

						<button class="button-edit" @click="show_users = item" title="Usuários">
							<i class="fa fa-fw fa-user"></i>
						</button>

						<!--
						<button class="button-remove" @click="remove(item.id)" title="Excluir">
							<i class="fa fa-fw fa-trash"></i>
						</button>
						-->

					</Table>

				</div>

			</div>
		</div>

		<AdminCompanyForm v-if="current" :current="current" />

		<AdminCompanyUsers v-if="show_users" :current="show_users" />

		<AdminCompanyDocument v-if="show_documents" :current="show_documents" />

	</div>
</template>

<script>
import Api from "@/lib/Api";

import Table from "@/components/Table";
import AdminCompanyForm from "./AdminCompany/AdminCompanyForm";
import AdminCompanyUsers from "./AdminCompany/AdminCompanyUsers";
import AdminCompanyDocument from "./AdminCompany/AdminCompanyDocument";

export default {
	name: "AdminCompany",

	components: { Table, AdminCompanyForm, AdminCompanyUsers, AdminCompanyDocument },

	data: function() {
		return {
			search: "",

			loading: true,
			list: [],
			page: 0,
			total: 0,
			headers: {
				id: "#",
				name: "Nome",
				address: "Endereço",
				created_at: "Cadastro"
			},
			modifiers: {
				created_at: function(s) {
					return (new Date(s)).toLocaleString();
				}
			},

			current: false,
			show_users: false,
			show_documents: false,
		};
	},


	mounted: function() {
		this.load();
	},


	activated: function() {
		this.load();
	},


	methods: {
		load: async function(is_search) {
			let form = {};

			if (this.search) {
				form.search = this.search;
			}

			if (is_search) {
				this.page = 0;
			}

			form.page = this.page;

			this.list = [];
			this.loading = true;
			let res = await Api.post_admin("company/list", form);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.list = res.data;
			this.total = res.total;
		},

		remove: async function(id) {
			let confirm;

			confirm = await this.$alert.confirm("Você tem certeza que deseja excluir essa empresa?");
			if (!confirm) return;

			confirm = await this.$alert.confirm("Essa ação removerá TODOS OS DADOS da empresa, inclusive usuários, notas e vínculos. CONTINUAR?");
			if (!confirm) return;

			this.loading = true;
			let res = await Api.post_admin("company/delete", {id: id});
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
			}

			this.load();
		}
	}
}
</script>

<style scoped>
		
.admin-filter-wrapper {
	position: relative;
	float: right;
	width: 200px;
	height: 30px;
	margin-top: 15px;
	color: #999;
}

.admin-filter-wrapper > i {
	position: absolute;
	top: 7px;
	left: 7px;
}

.admin-filter-input {
	position: absolute;
	width: 100%;
	height: 30px;
	padding-left: 30px;
	border-radius: 4px;
	border: 1px solid #ccc;
}


.admin-create-btn {
	float: right;
	margin-top: 16px;
	margin-left: 15px;
	padding-left: 15px;
	padding-right: 15px;
}

</style>